export const PACKAGE_DEFINITIONS = [
  ['3_months', 1, 3], ['6_months', 1, 6], ['12_months', 1, 12],
  ['24_months', 1, 24], ['36_months', 1, 36], ['48_months', 1, 48],
  ['unlimited', 1, 999], ['2k_12_months', 2, 12], ['2k_24_months', 2, 24],
  ['2k_36_months', 2, 36], ['2k_48_months', 2, 48], ['2k_unlimited', 2, 999],
].map(([id, max_connections, duration]) => ({ id, max_connections, duration }));

export const PACKAGE_PRICING_URL = 'https://tivigo.store/endpoint.php?endpoint=package_pricing';

export const isValidEurTryRate = (rate) => typeof rate === 'number' && Number.isFinite(rate)
  && rate >= 0.0001 && rate <= 1000000 && /^\d+(?:\.\d{1,4})?$/.test(String(rate));

export const unavailablePackagePricing = () => ({
  available: false,
  currency: '',
  eur_try_rate: null,
  plans: PACKAGE_DEFINITIONS.map((plan) => ({ ...plan, price: null })),
});

export function normalizePackagePricing(data) {
  if (!data || !['TRY', 'EUR'].includes(data.currency) || !/^[a-f0-9]{64}$/.test(data.revision || '')) {
    throw new Error('Paket fiyatları doğrulanamadı.');
  }
  const eurTryRate = data.eur_try_rate ?? null;
  if (eurTryRate !== null && !isValidEurTryRate(eurTryRate)) {
    throw new Error('Euro kuru doğrulanamadı.');
  }
  const plans = PACKAGE_DEFINITIONS.map((definition) => {
    const matches = (Array.isArray(data.plans) ? data.plans : []).filter((plan) => plan.id === definition.id);
    const plan = matches[0];
    if (matches.length !== 1 || plan.duration !== definition.duration || plan.max_connections !== definition.max_connections
      || (data.available === true && (!Number.isInteger(plan.price) || plan.price <= 0))) {
      throw new Error('Paket fiyat listesi eksik veya geçersiz.');
    }
    return { ...definition, price: data.available === true ? plan.price : null };
  });
  return { ...data, eur_try_rate: eurTryRate, available: data.available === true, plans };
}

export async function loadPackagePricing({ guestCurrency = '' } = {}) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 8000);
  try {
    const token = typeof window === 'undefined' ? '' : window.localStorage.getItem('xtream_api_token') || '';
    const url = !token && ['TRY', 'EUR'].includes(guestCurrency)
      ? `${PACKAGE_PRICING_URL}&guest_currency=${guestCurrency}` : PACKAGE_PRICING_URL;
    const response = await fetch(url, {
      cache: 'no-store', signal: controller.signal,
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
    });
    const payload = await response.json();
    if ((window.localStorage.getItem('xtream_api_token') || '') !== token) throw new Error('Hesap değişti.');
    if (!response.ok || payload?.success !== true) throw new Error('Paket fiyatları alınamadı.');
    if (token && payload.data?.pricing_source !== 'account') throw new Error('Hesap tarifesi doğrulanamadı.');
    return normalizePackagePricing(payload.data);
  } finally {
    clearTimeout(timer);
  }
}

export const packageLabel = (duration) => duration === 999 ? 'Sınırsız Paket' : `${duration} Aylık Paket`;
export const formatPackagePrice = (value, currency = 'TRY') => (
  value == null ? '—' : `${Number(value).toLocaleString('tr-TR', { maximumFractionDigits: 2 })} ${currency === 'EUR' ? '€' : 'TL'}`
);
